import type { ID } from '@octopus-do/octopus-project-core'
import type { AppState } from '@store/types'

import { selectDashboard } from './selectDashboard'

// The team workspace the user can open settings for: their own one first,
// otherwise any team workspace settings are available in.
export const getTeamWorkspace = (userId: ID) => (state: AppState) => {
  const available = selectDashboard(state).filter(
    (workspace) =>
      workspace.type === 'team' &&
      !workspace.expired &&
      workspace.features.includes('team_settings')
  )

  const owned = available.find(({ ownerId }) => ownerId === userId)

  return owned ?? available[0] ?? null
}
